import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import styles from '../_style/index.less';
import { dispatch } from '@@/store';
import { StickyContainer } from '@/components';
import { showCarDetail } from '@/shared/utils';
const mapStateToProps = (rootState) => ({
    _state: rootState.realtimeMonitoring,
});
class TopInfo extends Component {
    constructor(props) {
        super(props);
        this.switchStatusName = (status) => {
            let name = '';
            switch (status) {
                case 2:
                    name = '待竞价';
                    break;
                case 3:
                    name = '竞价中';
                    break;
                case 50:
                    name = '结标中';
                    break;
                case 5:
                    name = '成交';
                    break;
                case 9:
                    name = '投标中';
                    break;
                case 6:
                    name = '流拍';
                    break;
                case 4:
                    name = '交易结束';
                    break;
            }
            return name;
        };
    }
    componentDidMount() {
        dispatch.realtimeMonitoring.getCarDetail({});
    }
    render() {
        const { topCarDetails } = this.props._state;
        const { carmodelName, license, locationName, vin, rankDesc, rankLevel, firstImage, goodsIdStr, status } = topCarDetails;
        const statusName = this.switchStatusName(status);
        return (<StickyContainer>
        <div className={styles.top_info}>
          <div className={styles.top_left}>
            <img src={firstImage}/>
          </div>
          <div>
            <div onClick={() => {
            showCarDetail(goodsIdStr);
        }} className={styles.top_title}>
              {carmodelName}
            </div>
            <div className={styles.top_cont}>
              <span>{statusName}</span>
              <span>{license}</span>
              <span>{rankLevel}{rankDesc}</span>
              <span>{locationName}</span>
              <span>VIN码：{vin}</span>
            </div>
          </div>
        </div>
      </StickyContainer>);
    }
}
export default connect(mapStateToProps)(TopInfo);
